import React, { useState, useEffect } from "react";
import asideimage from "../../../../asset/images/aside-image.png";
import dashboardicon from "../../../../asset/images/red-dashboard-icon.png";
import Spinner from "../../../../UI/Spinner/Spinner";
import configure from "../../../../asset/images/configure.png";
import accountManagementIcon from "../../../../asset/images/account-management.png";
import leftArrow from "../../../../asset/images/path-left-side.png";
import rightArrow from "../../../../asset/images/path-right-side.png";
import { Link } from "react-router-dom";
import userIcon from "../../../../asset/images/User.svg";
import Dashboard from "../../../../asset/images/Dashboard.svg";
import TMS from "../../../../asset/images/TMS.svg";
import Reports from "../../../../asset/images/Reports.svg";
import Masters from "../../../../asset/images/masters.svg";
import Settings from "../../../../asset/images/settings.svg";
import Inward from "../../../../asset/images/inward.svg";

const iconsObj = {
  "Dashboard": Dashboard,
  "User Management": userIcon,
  "AAJ Swift TMS": TMS,
  "Reports": Reports,
  "Masters": Masters,
  "Settings": Settings,
  "Inward": Inward
} 

export const AppMenus = (props) => {
  const [collapseLeftMenu, setcollapseLeftMenu] = useState(false);
  const [selectedModule, setselectedModule] = useState("");
  const [selectedsubModule, setselectedSubModule] = useState("");
  const [menuData, setMenuData] = useState([]);
  const [hoveredModule, setHoveredModule] = useState("");

  const handleLeftMenu = () => {
   // props.collapseLeftMenu();
    setcollapseLeftMenu(!collapseLeftMenu);     
    props.collapseLeftMenu();
  };
 
  useEffect(() => {
    console.log(props.appModules,"****props.appModules****")
    setMenuData(props.appModules);
  });
  const SelectModule = (moduleCode) => {
    if (selectedModule === moduleCode) setselectedModule("");
    else setselectedModule(moduleCode);
  };
  const getIcon = (name) => {
    
    return iconsObj[name];
  }


  const handleMouseEnter = (moduleHover) => {
    setHoveredModule(moduleHover);
  }; 
  const handleMouseLeave = () => {
    setHoveredModule(null);
  };

  //console.log("hovered", hoveredModule)

  return (
    <div>
      <div
        className={
          collapseLeftMenu === true
            ? "left-dashbord scrollbar-styling"
            : "left-dashbord scrollbar-styling close "
        }        
      >
        <div className="aside-content">
          <div className="aside-bar">
            <div className="aide-text">
              <span>Welcome Back!</span>
              <span className="aside-txt">
                {localStorage.getItem("FirstName")}{" "}
                {localStorage.getItem("LastName")}
              </span>
            </div>
            <div className={ collapseLeftMenu === true
            ? "aside-image"
            : "aside-image close"} >
              <img src={asideimage} alt="aside-image" />
            </div>
          </div>
          <span className="aside-line-alignment"></span>
        </div>
        {props.loading && (
          <div className="aside-dashboard-content">
            <Spinner />
          </div>
        )}

      <div style={{ display: `${collapseLeftMenu ? 'block' : 'flex'}`, flexDirection: "column", justifyContent: "center", alignItems: "end"}}>

        {collapseLeftMenu ? 
           <div className="aside-dashboard-content">
            <div className="aside-dashboard-icon">
              <Link to={"/"} className="dashboard">
                <span className="dashboard">
                  <img
                    // src={dashboardicon}
                    src={getIcon("Dashboard")}
                    alt="dashboard-icon"
                    className="dashboard"
                    onClick={() => handleLeftMenu()}                    
                  ></img>
                  {/* added by riya click handler */}
                </span>
              </Link>
              <span style={{ color: "red !imporrtant" }}>
                <Link
                  to={"/"}
                  className="dashboard"
                  style={{ color: "red !imporrtant" }} 
                >
                  Dashboard
                </Link>
              </span>
            </div>
            <span className="aside-line-alignment"></span>
          </div>
        :  <div style={{ margin: "5px", padding: "5px" }} to={"/"} className={collapseLeftMenu ? 'dashboard' : "dashboard random"}>
        <span className="dashboard">
          <img
            src={getIcon("Dashboard")}
            alt="dashboard-icon"
            className="dashboard"     
            onClick={() => handleLeftMenu()}         
          ></img>
        </span>
      </div> }
        </div>
        {/* Start Account Menu Render */}
        {/* {menuData
          .filter((x) => x.isAccount === false && x.module === "Mod_1")
          .map((item) => {
            return (
              <div className="aside-dashboard-content">
                <div className="aside-dashboard-icon">
                  <span>
                    <img src={dashboardicon} alt="dashboard-icon" />
                    {item.name}
                  </span>
                </div>
                <span className="aside-line-alignment"></span>
              </div>
            );
          })} */}
        {/* End Account Menu Render */}
        {/* Start Account Menu Render */}
        {menuData
          .filter((x) => x.isAccount === true && x.module != "Mod_1")
          .map((item) => {
            return (
              <div className="aside-dashboard-content">
                <div className="aside-dashboard-icon">
                  <span>
                    {/* <img src={dashboardicon} alt="dashboard-icon" /> */}
                    src={getIcon("Dashboard")}
                  </span>
                  <span>{item.name}</span>
                  
                </div>
                <span className="aside-line-alignment"></span>
              </div>
            );
          })}
        {/* End Account Menu Render */}
        {/* Start Other Menu Render */}
        <div style={{ display: `${collapseLeftMenu ? 'block' : 'flex'}`, flexDirection: "column", justifyContent: "center", alignItems: "end" }}>
          {menuData
            .filter((x) => x.isAccount === false && x.module != "Mod_1")
            .map((item) => {
              return (
                <>
                  {collapseLeftMenu ?
                   <div className="aside-dashboard-content">
                   <div className="aside-dashboard-icon content-allignment-left-side">
                     <span>
                       <img src={getIcon(item.name)} alt="dashboard-icon"
                        onClick={() => handleLeftMenu()}       
                       />
                          {/* added by riya click handler */}
                     </span>
                     <span
                       className="user-text"
                       onClick={() => {
                         SelectModule(item.module);
                       }}
                     >
                       {item.name}
                     </span>
                     <span
                       className="arrow-icon"
                       onClick={() => {
                         SelectModule(item.module);                                                   
                       }}
                     >
                       <i
                         className="fa fa-angle-down  fa-icon"
                         onClick={() => {
                           SelectModule(item.module);
                         }}
                       ></i>
                     </span>
                     <div
                       className="role-user"
                       style={
                         selectedModule == item.module
                           ? { display: "block" }
                           : { display: "none" }
                       }
                     >
                       <ul>
                         {item.children.map((item) => {
                           return (
                             <li
                               onClick={() => {
                                 setselectedSubModule(item.module);
                               }}
                               className={
                                 selectedsubModule === item.module ? "active" : ""
                               }
                             >
                               <Link to={item.url}>{item.labelCode}</Link>
                             </li>
                           );
                         })}
                       </ul>
                     </div>
                   </div>
                   <span className="aside-line-alignment"></span>
                 </div>
                    :
                    <div style={{ padding: "5px", margin: "5px" }}>
                    <span onMouseEnter={() => {
                      handleMouseEnter(item.module)
                    }}
                      onMouseLeave={() => {
                        handleMouseLeave();
                      }} className={collapseLeftMenu ? 'dashboard' : "dashboard random"}>
                      <span className="dashboard">
                        <img src={getIcon(item.name)} alt="dashboard-icon" 
                        onClick={() => handleLeftMenu()}   
                        />
                      </span>
                    </span>
                    <div
                      className="hover-text"
                      style={
                        hoveredModule == item.module
                          ? { display: "inline-block" }
                          : { display: "none" }
                      }
                    >
                      <ul>
                        <li>{item.name}  </li>
                        {item.children.map((item) => {
                          return (
                            <li
                              onClick={() => {
                                setselectedSubModule(item.module);
                              }}
                              className={
                                selectedsubModule === item.module ? "active" : ""
                              }
                            >
                              
                              <Link to={item.url}>{item.labelCode}</Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  
                  }
                </>
              );
            })}
        </div>
        {/* End Other Menu Render */}
      </div>
      {/* <!--c left side arrow icon --> */}
      <div
        className={
          collapseLeftMenu === true
            ? "left-side-arrow-icon"
            : "left-side-arrow-icon close-icon"
        }
        onClick={() => handleLeftMenu()}
      >
        <img
          src={leftArrow}
          alt="left side arrow icon"
          onClick={() => handleLeftMenu()}
        />
      </div>
      {/* <div className="right-side-arrow-icon">
            <img src={rightArrow} alt="left side arrow icon" />
        </div> */}
    </div>
  );
};
export default AppMenus;
